import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconDownload.module.css';

const IconDownload = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill="#25D5FF"
        fillRule="evenodd"
        d="M10.2 13.974V.602h1.6V13.87l3.433-3.435 1.133 1.133-5.344 5.344-5.766-5.325 1.084-1.174 3.86 3.561zm-8 5.828v-9.6H.6v11.2h20.8v-11.2h-1.6v9.6H2.2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

const { string } = PropTypes;

IconDownload.defaultProps = {
  className: null,
  rootClassName: null,
};

IconDownload.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconDownload;
